import weekIcon from 'src/public/img/cbt-dashboard-icon.svg';
import congratulationsIcon from 'src/public/img/illustration-heartbroken.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { AvoidanceStep } from '../stepComponents/AvoidanceStep';
import { EmotionalDistressPlanStep } from '../stepComponents/EmotionalDistressPlanStep';
import { EmotionalDistressStep } from '../stepComponents/EmotionalDistressStep';
import { LearningAboutEmotionalDistressStep } from '../stepComponents/LearningAboutEmotionalDistressStep';
import { NotWantingEmotionsStep } from '../stepComponents/NotWantingEmotionsStep';
import { ProgramOverviewStep } from '../stepComponents/ProgramOverviewStep';
import { StrongEmotionsStep } from '../stepComponents/StrongEmotionsStep';
import { WhatDoesThisLookLikeStep } from '../stepComponents/WhatDoesThisLookLikeStep';
import { WhatIsEmotionalDistressStep } from '../stepComponents/WhatIsEmotionalDistressStep';
import { WhatsNextStep } from '../stepComponents/WhatsNextStep';
import { CBTProgramWeekOneStep } from './weekOne';

const steps: (ProgramSharedStep | CBTProgramWeekOneStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.ProgramOverviewStep,
    CBTProgramWeekOneStep.WhatIsEmotionalDistressStep,
    CBTProgramWeekOneStep.EmotionalDistress,
    CBTProgramWeekOneStep.LearningAboutEmotionalDistressStep,
    CBTProgramWeekOneStep.WhatDoesThisLookLikeStep,
    CBTProgramWeekOneStep.StrongEmotionsStep,
    CBTProgramWeekOneStep.NotWantingEmotionsStep,
    CBTProgramWeekOneStep.AvoidanceStep,
    CBTProgramWeekOneStep.WhatsNextStep,
    ProgramSharedStep.PlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: ProgramSharedStep.ProgramOverviewStep,
        component: ProgramOverviewStep,
        tooltip: 'Uplift Program Overview',
    },
    {
        id: CBTProgramWeekOneStep.WhatIsEmotionalDistressStep,
        component: WhatIsEmotionalDistressStep,
        tooltip: 'What is emotional distress?',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekOneStep.EmotionalDistress,
        component: EmotionalDistressStep,
        tooltip: 'Areas of Distress',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CBTProgramWeekOneStep.LearningAboutEmotionalDistressStep,
        component: LearningAboutEmotionalDistressStep,
        tooltip: 'Learning about emotional distress',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekOneStep.WhatDoesThisLookLikeStep,
        component: WhatDoesThisLookLikeStep,
        tooltip: 'What does this look like?',
    },
    {
        id: CBTProgramWeekOneStep.StrongEmotionsStep,
        component: StrongEmotionsStep,
        tooltip: 'How does this apply to you: Strong Emotions',
        noButtons: true,
    },
    {
        id: CBTProgramWeekOneStep.NotWantingEmotionsStep,
        component: NotWantingEmotionsStep,
        tooltip: 'How does this apply to you: Not Wanting Emotions',
        noButtons: true,
    },
    {
        id: CBTProgramWeekOneStep.AvoidanceStep,
        component: AvoidanceStep,
        tooltip: 'How does this apply to you: Avoidance',
        noButtons: true,
    },
    {
        id: CBTProgramWeekOneStep.WhatsNextStep,
        component: WhatsNextStep,
        tooltip: `What's next?`,
        flexGrow: false,
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: EmotionalDistressPlanStep,
        tooltip: `This week...`,
    },
];

const t = (key: string) => `cbt:week-1.data.${key}`;

export const weekOneData = {
    id: ProgramWeekEnum.WeekOne,
    weekNumber: 0,
    readableWeekNumber: 1,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
